import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import toast from "react-hot-toast";
import I18n from "i18n-js";

import api from "../../api";

import { MAX_ACTIVE_PLANS } from "../config/constants";

import ActionButton from "../../commons/ActionButton";

import publishIcon from "../../assets/icons/publish.svg";

const PublishButton = ({ plan, canPublish }) => {

  const [loading, setLoading] = useState(false);

  const publishPlan = () => {
    setLoading(true);

    api.post(`/development_plans/${plan?.uuid}/publish`)
      .then(res => {
        console.log(res);
        setTimeout(() => {
          toast.success(<b>{I18n.t("common.published_successfully")}</b>);

          if (res.data && res.data.redirect_to) {
            window.location.assign(res.data.redirect_to);
          }
        }, 500);
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.message) {
          toast.error(<b>{err.response.data.message}</b>);
        } else {
          toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
        }
        setLoading(false);
        console.error(err);
      });
  }

  return (
    <OverlayTrigger
      show={canPublish ? false : undefined}
      trigger={["hover", "focus"]}
      placement="bottom"
      overlay={
        <Tooltip>
          {I18n.t("pdp.actions.plan.publish.tooltip.has_pending_plan", { count: MAX_ACTIVE_PLANS })}
        </Tooltip>
      }
    >
      <ActionButton
        loading={loading}
        title={I18n.t("pdp.actions.plan.publish.title")}
        icon={publishIcon}
        disabled={!canPublish}
        onClick={publishPlan}
      />
    </OverlayTrigger>
  );
}

export default PublishButton;
